import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'dibs-jquery-shim';
import SV from 'server-vars';
import get from 'lodash.get';
import { trackEvent } from 'dibs-tracking';
import { getBuyerHeaderClient } from 'dibs-buyer-layout/src/entries/index';
import chatUtils from '../../utils/social/chat.es';
import { getEnvironment } from '../../relayEnvironmnentProvider.es';
import authModalLoader from '../../../auth/authModalLoader';
import User from '../../models/User';
import { isMobile } from '../commonjs/screenSize.es';
import authModalCheck from './authModalCheck';

let NavMobileRenderer;

function initializeMobileNav({ context, store } = {}) {

    ReactDOM.render(
        // Using a Renderer to not make another call to get Nav Data to pass down to Backbone View
        // Can't use `preLoadedData` because keys for data comes back with hash suffix e.g. '_navigation2R0KfN'
        React.createElement(NavMobileRenderer, { context, store }),
        document.createElement('div')
    );

    store.subscribe(() => {
        const { header } = store.getState();
        const { isUserTypeTrade } = header;

        if (isUserTypeTrade) {
            const mastheadEl = get(document.getElementsByClassName('masthead'), '[0]', null);
            const messageContainerEl = get(document.getElementsByClassName('messageBannerContainer'), '[0]', null);

            if (mastheadEl && !mastheadEl.classList.contains('is-trade')) {
                mastheadEl.className += ' is-trade';
            }
            if (messageContainerEl && !messageContainerEl.classList.contains('is-trade')) {
                messageContainerEl.className += ' is-trade';
            }
        }
    });
}

function initializeNav() {

    // Show login/registration modal if special query param is present
    authModalCheck.init();

    const { updateBuyerHeaderUserState, store } = getBuyerHeaderClient(
        getEnvironment(),
        document.getElementById('js-header'),
        {
            state: {
                header: {
                    ...(SV.get('header.preLoadedState.header') || {}),
                    showAuthModal: authModalLoader.show.bind(authModalLoader),
                    showChatUtils: chatUtils.show.bind(chatUtils),
                    logoutUser: User.logout.bind(User, true),
                    trackEvent
                }
            }
        }
    );

    $.subscribe('login:change', updateBuyerHeaderUserState);
    return { store };
}

export const init = (context) => {
    const { store } = initializeNav();

    const loadMobileNav = () => {
        require.ensure('./components/NavMobileRenderer', () => {
            NavMobileRenderer = require('./components/NavMobileRenderer');
            initializeMobileNav({ context, store });
        });
    };

    if (isMobile()) {
        loadMobileNav();

    } else {
        window.addEventListener('resize', () => {

            if (isMobile() && !NavMobileRenderer) {
                loadMobileNav();
            }
        });
    }

};

export default { init };



// WEBPACK FOOTER //
// ./assets/js/global/core/nav/nav.es.js